import type { ReactElement } from 'react';
import { PackageContainer } from '../common/PackageContainer';
import { PackageDetails } from '../common/PackageDetails';
import { PackageGroup } from '../common/PackageGroup';
import { PackagesByCategory } from '../common/PackagesByCategory';
import { MeetingPackageCategoryLabels } from 'packages/enums';
import type {
  MeetingPackage,
  Service,
  PackageSelectComponent,
  Package
} from 'packages/types';

type Props = {
  packages: MeetingPackage[];
  allServices: Service[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

type SinglePackageProps = {
  pkg: MeetingPackage;
  allServices: Service[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

function SinglePackage(props: SinglePackageProps) {
  return (
    <PackageContainer pkg={props.pkg} onPackageViewed={props.onPackageViewed}>
      <PackageDetails
        pkg={props.pkg}
        allServices={props.allServices}
        PackageSelectComponent={props.PackageSelectComponent}
      />
    </PackageContainer>
  );
}

export function MeetingPackageList(props: Props): ReactElement {
  return (
    <PackagesByCategory
      categoryLabels={MeetingPackageCategoryLabels}
      packages={props.packages}
      PackageGroup={PackageGroup}
      Package={SinglePackage}
      packageProps={{
        allServices: props.allServices,
        PackageSelectComponent: props.PackageSelectComponent,
        onPackageViewed: props.onPackageViewed
      }}
    />
  );
}
